const topLinks = document.querySelectorAll(".top-link");
const megaMenus = document.querySelectorAll(".mega-menu");
const body = document.querySelector("body");
const header = document.querySelector(".header-item-wrapper")

// Hide all menus
function hideAllMenus() {
  megaMenus.forEach(menu => {
    menu.style.display = "none";
    body.style.overflow = "auto"
  });
}

header.addEventListener("mouseenter",()=>{
  megaMenus.forEach(menu => {
    menu.style.display = "none";
    body.style.overflow = "auto"
  });
})

topLinks.forEach(link => {
  const linkTitle = link.getAttribute("link-handle")?.toLowerCase();

  link.addEventListener("mouseenter", () => {

    hideAllMenus();

    megaMenus.forEach(menu => {
      const menuTitle = menu.getAttribute("menu-title")?.toLowerCase();

      if (menuTitle === linkTitle) {
        menu.style.display = "flex";
        body.style.overflowX  = "hidden"
      }
    });
  });
});

// Keep menu open while hovering it
megaMenus.forEach(menu => {
  menu.addEventListener("mouseenter", () => {
    menu.style.display = "flex";
    body.style.ooverflowX  = "hidden"
  });

  menu.addEventListener("mouseleave", () => {
    menu.style.display = "none";
    body.style.overflow = "auto"
  });
});


